module.exports = __webpack_public_path__ + "img/certif_017.3ca516a3.jpg";